/**
 * Route for `cap-over-delivery-cancel`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { CapOverDeliveryCancelPage } from "../features/cap-over-delivery-cancel/CapOverDeliveryCancelPage";

export const capOverDeliveryCancelRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/cap-over-delivery-cancel",
	component: CapOverDeliveryCancelPage,
});

export default capOverDeliveryCancelRoute;
